export default class RepaintHeader {
  static init () {
    this.header = document.querySelector('header')
    this.repaintRequired = false

    window.addEventListener('scroll', () => {
      if (window.scrollY > this.header.offsetHeight) {
        this.repaintRequired = true
      } else {
        this.repaintRequired = false
      }

      this.render()
    })
  }

  static render () {
    if (this.repaintRequired === this.lastProcessedState) return

    if (this.repaintRequired) {
      this.header.classList.add('repainted')
      document.body.classList.add('header_repainted')
    } else {
      this.header.classList.remove('repainted')
      document.body.classList.remove('header_repainted')
    }
  }
}
